
<script>
import {
  calcDeltaPrice,
  formatThousands
} from '@/utils/helpers'
import AviaticketFlightInfo from './FlightInfo.vue'
import baggageIcon from '@/assets/images/icons/baggage.svg?inline'
import handBaggageIcon from '@/assets/images/icons/handBaggage.svg?inline'
import seatSelectionIcon from '@/assets/images/icons/seatSelection.svg?inline'
import ticketReturnIcon from '@/assets/images/icons/ticketReturn.svg?inline'
import withoutBaggageIcon from '@/assets/images/icons/withoutBaggage.svg?inline'
import withoutHandBaggageIcon from '@/assets/images/icons/withoutHandBaggage.svg?inline'
import withoutSeatSelectionIcon from '@/assets/images/icons/withoutSeatSelection.svg?inline'
import withoutTicketReturnIcon from '@/assets/images/icons/withoutTicketReturn.svg?inline'

export default {
  name: 'aviatickets-tarrifs',
  components: {
    AviaticketFlightInfo,
    baggageIcon,
    handBaggageIcon,
    seatSelectionIcon,
    ticketReturnIcon,
    withoutBaggageIcon,
    withoutHandBaggageIcon,
    withoutSeatSelectionIcon,
    withoutTicketReturnIcon
  },
  props: {
    aviaticketId: {
      type: String,
      required: true
    },
    flightIndex: {
      type: Number,
      required: true
    }
  },
  data: () => ({}),
  computed: {
    getFlight() {
      return this.$store.getters['cart/getFlight'](this.flightIndex)
    },
    getFlightTarrifs() {
      return this.$store.getters['cart/getFlightTarrifs']({
        flightIndex: this.flightIndex,
        aviaticketId: this.aviaticketId
      })
    },
    isLoading() {
      return this.getFlightTarrifs.isLoading
    }
  },
  created() {
    this.$store.dispatch('cart/getFlightTarrifs', {
      aviaticketId: this.aviaticketId,
      aviaSearchId: this.getFlight.searchId,
      recommendationId: this.aviaticketId,
      flightIndex: this.flightIndex,
      currency: this.$store.getters['cart/getCartPrice'].currency
    })
  },
  methods: {
    isCurrentActive(id) {
      return id === this.getFlight.current.id
    },
    select(tarrifId) {
      this.$store.commit('cart/updateFlightTarrif', {
        aviaticketId: this.aviaticketId,
        flightIndex: this.flightIndex,
        tarrifId
      })
    },
    calcDeltaPrice(price) {
      return this.getFlight.current.price.amount === 0
        ? this.formatThousands(price)
        : calcDeltaPrice(this.getFlight.current.price.amount, price)
    },
    formatThousands: number => formatThousands(number)
  }
}
</script>

<template>
  <div class="cart__aviatickets-tarrifs--wrapper">
    <b-loading
      v-if="isLoading"
      :is-full-page="false"
      :active="isLoading"
    />
    <div
      v-if="!isLoading && getFlightTarrifs.hasError"
    >
      <h2
        v-for="(item, index) in getFlightTarrifs.errors"
        :key="index"
        class="cart__penalties--error"
      >
        {{ item }}
      </h2>
    </div>
    <b-table
      v-if="!isLoading && !getFlightTarrifs.hasError"
      :data="getFlightTarrifs.collection"
      :row-class="(row, index) => 'cart__aviatickets-tarrifs--item'"
      class="cart__aviatickets-tarrifs cart__table"
    >
      <template slot-scope="tarrif">
        <b-table-column>
          <b-tooltip
            type="is-white"
            :multilined="true"
            :square="true"
            :label="tarrif.row.name"
          >
            <p class="cart__aviatickets-tarrifs--name">
              {{ tarrif.row.name }}
            </p>
          </b-tooltip>
        </b-table-column>
        <b-table-column>
          <div class="cart__aviatickets-tarrifs--services">
            <b-tooltip
              v-if="tarrif.row.baggage.included"
              type="is-white"
              :multilined="true"
              :square="true"
              :label="tarrif.row.baggage.description.join('\n')"
            >
              <baggageIcon />
            </b-tooltip>
            <withoutBaggageIcon
              v-if="!tarrif.row.baggage.included"
            />
            <b-tooltip
              v-if="tarrif.row.handBaggage.included"
              type="is-white"
              :multilined="true"
              :square="true"
              :label="tarrif.row.handBaggage.description.join('\n')"
            >
              <handBaggageIcon />
            </b-tooltip>
            <withoutHandBaggageIcon
              v-if="!tarrif.row.handBaggage.included"
            />
            <b-tooltip
              v-if="tarrif.row.seatSelection.included"
              type="is-white"
              :multilined="true"
              :square="true"
              :label="tarrif.row.seatSelection.description.join('\n')"
            >
              <seatSelectionIcon />
            </b-tooltip>
            <withoutSeatSelectionIcon
              v-if="!tarrif.row.seatSelection.included"
            />
            <b-tooltip
              v-if="tarrif.row.ticketReturn.included"
              type="is-white"
              :multilined="true"
              :square="true"
              :label="tarrif.row.ticketReturn.description.join('\n')"
            >
              <ticketReturnIcon />
            </b-tooltip>
            <withoutTicketReturnIcon
              v-if="!tarrif.row.ticketReturn.included"
            />
          </div>
        </b-table-column>
        <b-table-column
          :centered="true"
        >
          <p class="cart__aviatickets-tarrifs--price">
            {{ calcDeltaPrice(tarrif.row.price.amount) }}
            {{ tarrif.row.price.currency }}
          </p>
        </b-table-column>
        <b-table-column>
          <div class="cart__table--center">
            <aviaticket-flight-info
              :aviaticket-id="aviaticketId"
              :tarrif-id="tarrif.row.id"
              :flight-index="flightIndex"
            />
          </div>
        </b-table-column>
        <b-table-column>
          <a
            v-if="!isCurrentActive(tarrif.row.id)"
            href="javascript:;"
            class="rex-btn rex-btn--bold rex-btn--sm"
            @click="select(tarrif.row.id)"
          >
            <span>Выбрать</span>
          </a>
          <a
            v-if="isCurrentActive(tarrif.row.id)"
            href="javascript:;"
            class="rex-btn rex-btn--bold rex-btn--sm active"
          >
            <span>Выбран</span>
          </a>
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>
